import React, { useEffect } from "react";
import { useTranslation } from "react-i18next";
import DataTable from "../../../../components/DataTable/DataTable";
import { Link } from "react-router-dom";
import automService from "../../../../services/AutomService/AutomService";
import { alertState, personalizationState, schedulerNexRunTimes } from "../../../../recoil-store/recoil-state";
import { useSetRecoilState, useRecoilValue } from 'recoil';
import { convertToDateFormat } from '../../../../helpers/helper';


function ScheduleMonitor(props) {
    const setAlert = useSetRecoilState(alertState);
    const personalization = useRecoilValue(personalizationState);
    const nextRunTimes = useRecoilValue(schedulerNexRunTimes);
    const {
        loading,
        setSearchKeyData,
        setSearchData,
        searchData,
        setCustomColumn,
        customColumn,
        setLoading,
        setData,
    } = props;
    const { t } = useTranslation();

    useEffect(() => {
        getNextRunTimesOfSchedulers();
    }, []);

    useEffect(() => {
        if (nextRunTimes) {
            setData(nextRunTimes);
            setSearchData(nextRunTimes);
        }
    }, [nextRunTimes])

    const getNextRunTimesOfSchedulers = async () => {
        setLoading(true);
        const result = await automService.getNextRunTimesOfSchedulers();
        if (result.status) {
            setData(result.data);
            setSearchData(result.data);
        } else {
            setAlert(alert => ({ ...alert, show: true, message: t('MESSAGES.MONITORING.' + result.message), severity: 'error' }))
        }
        setLoading(false);
    }

    useEffect(() => {
        const column = [
            {
                id: -1,
                label: "",
                name: "",
                options: {
                    filter: false,
                    sort: false,
                },
            },
            {
                id: 0,
                name: "id",
                label: " ",
                options: {
                    filter: false,
                    sort: false,
                    customBodyRenderLite: (dataIndex, rowIndex) => {
                        if (searchData && searchData[dataIndex]) {
                            return <span>{dataIndex + 1}.</span>;
                        }
                    },
                },
            },
            {
                id: 1,
                name: "autom_name",
                label: t("MESSAGES.MONITORING.AUTOM-NAME"),
                options: {
                    filter: true,
                    sort: true,
                    customBodyRenderLite: (dataIndex, rowIndex) => {
                        if (searchData && searchData[dataIndex]) {
                            return (
                                <div>
                                    {
                                        <Link
                                            data-test="credential-link"
                                            to={`/automs/${searchData[dataIndex].autom_id}/autom/edit`}
                                        >
                                            {searchData[dataIndex]?.autom_name}
                                        </Link>
                                    }
                                </div>
                            );
                        }
                    },
                },
            },
            {
                id: 3,
                name: "scheduled_at",
                label: t("MESSAGES.MONITORING.NEXT-RUN-TIME"),
                options: {
                    filter: true,
                    sort: true,
                    customBodyRenderLite: (dataIndex) => {
                        if (searchData && searchData[dataIndex] && searchData[dataIndex]?.scheduled_at) {
                            return convertToDateFormat(searchData[dataIndex]?.scheduled_at, personalization.date_format);
                        } else {
                            return "-";
                        }
                    },
                },
            }
        ];
        setCustomColumn(column);
        setSearchKeyData(["autom_name"]);
    }, [searchData]);

    return (
        <div>
            <DataTable
                data={searchData}
                customColumns={customColumn}
                selectableRows={"none"}
                title={t("MESSAGES.MONITORING.AUTOM-MONITORING")}
                loading={loading}
            />
        </div>
    );
}

export default ScheduleMonitor;
